export const MOSCOW_REGION_ID = 1;
export const MOSCOW_DEFAULT_STORE_ID = 1;
export const OTHER_REGIONS_DEFAULT_STORE_IDS = [174, 178];
